<svg:circle />
<svg:text>!</svg:text>
